import { render } from "./ModalViewRRIM.vue?vue&type=template&id=b36e0a8e&scoped=true"
import script from "./ModalViewRRIM.vue?vue&type=script&lang=js"
export * from "./ModalViewRRIM.vue?vue&type=script&lang=js"

import "./ModalViewRRIM.vue?vue&type=style&index=0&id=b36e0a8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b36e0a8e"]])

export default __exports__